import {
  useLocation,
  useNavigate,
  useParams as useRouterParams,
  useSearchParams as useRouterSearchParams,
} from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();

  return {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    prefetch: () => undefined,
  };
};

export const usePathname = () => useLocation().pathname;

export const useSearchParams = () => {
  const [searchParams] = useRouterSearchParams();
  return searchParams;
};

export const useParams = useRouterParams;
